import React from "react";
import CopyrightIcon from '@mui/icons-material/Copyright';
import './MobileSticky.css';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

class MobileSticky extends React.Component {
    constructor(){
        super();
        this.state = {
            
        }
    }
 
    render() {
       
         return <div className="mob-sticky-cart pb-3 pt-3 ">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 ">
                                <div className="header-menu-nav">
                                    <ul className="menu-nav">
                                        <li className="pr-0">
                                            <div className="header-tools d-flex ">
                                                <div className="cart-info d-flex align-self-center">

                                                    <a href="/cart"><ShoppingCartIcon className="mob-cart-outline"/><span id="pro-count2" className="counter">0</span></a>
                                                </div>
                                            </div>
                                           
                                        </li>
                                        {/* <li className="pr-0 ">
                                           <a href="/cart"><span id="cart-amount">(Rs 500)</span></a>
                                        </li> */}
                                        <li className="pr-0 float-right">
                                            <a href="/cart">View All</a>
                                        </li>
                                    </ul>
                                </div>                                
                            </div>
                            </div>
                        </div>
                    </div>
               
        }
    }
    export default MobileSticky;